/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxTabsComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxtabs';

/**
 * Tabs
 */
@Component({
    selector: 'ngc-tabs',
    template: `<jqxTabs
                [animationType] = "animationType"
                [autoHeight] = "autoHeight"
                [closeButtonSize] = "closeButtonSize"
                [collapsible] = "collapsible"
                [contentTransitionDuration] = "contentTransitionDuration"
                [disabled] = "disabled"
                [enabledHover] = "enabledHover"
                [enableScrollAnimation] = "enableScrollAnimation"
                [initTabContent] = "initTabContent"
                [keyboardNavigation] = "keyboardNavigation"
                [next] = "next"
                [previous] = "previous"
                [position] = "position"
                [reorder] = "reorder"
                [rtl] = "rtl"
                [scrollAnimationDuration] = "scrollAnimationDuration"
                [selectedItem] = "selectedItem"
                [selectionTracker] = "selectionTracker"
                [scrollable] = "scrollable"
                [scrollPosition] = "scrollPosition"
                [scrollStep] = "scrollStep"
                [showCloseButtons] = "showCloseButtons"
                [toggleMode] = "toggleMode"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxTabs>`
})
export class NgcTabsComponent extends ControlComponent {
    @Input('animationType') animationType: any;
    @Input('autoHeight') autoHeight: any;
    @Input('closeButtonSize') closeButtonSize: any;
    @Input('collapsible') collapsible: any;
    @Input('contentTransitionDuration') contentTransitionDuration: any;
    @Input('disabled') disabled: any;
    @Input('enabledHover') enabledHover: any;
    @Input('enableScrollAnimation') enableScrollAnimation: any;
    @Input('initTabContent') initTabContent: any;
    @Input('keyboardNavigation') keyboardNavigation: any;
    @Input('next') next: any;
    @Input('previous') previous: any;
    @Input('position') position: any;
    @Input('reorder') reorder: any;
    @Input('rtl') rtl: any;
    @Input('scrollAnimationDuration') scrollAnimationDuration: any;
    @Input('selectedItem') selectedItem: any;
    @Input('selectionTracker') selectionTracker: any;
    @Input('scrollable') scrollable: any;
    @Input('scrollPosition') scrollPosition: any;
    @Input('scrollStep') scrollStep: any;
    @Input('showCloseButtons') showCloseButtons: any;
    @Input('toggleMode') toggleMode: any;
    @Input('theme') theme: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
}

/**
 * Tabs Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcTabsComponent],
    declarations: [NgcTabsComponent, jqxTabsComponent]
})
export class NgcTabsModule {
}